"use strict";

exports.__esModule = true;
exports.MAX_EMAIL_LENGTH = void 0;
exports.isValidEmail = isValidEmail;
// Anchored (^...$) so the whole value must be an address. The previous pattern
// was unanchored, so anything containing a valid address passed -- for example
// "<img src=q onerror=prompt(8)>a@b.com". (VAPT-02)
var EMAIL_PATTERN = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
var MAX_EMAIL_LENGTH = exports.MAX_EMAIL_LENGTH = 254;
function isValidEmail(value) {
  if (typeof value !== "string") {
    return false;
  }
  var trimmed = value.trim();
  if (!trimmed || trimmed.length > MAX_EMAIL_LENGTH) {
    return false;
  }
  return EMAIL_PATTERN.test(trimmed.toLowerCase());
}